import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { computed, inject, signal } from '@angular/core';
import { EventManager } from '@ms/core/service/event-manager.service';
import { patchState, signalStore, withComputed, withMethods } from '@ngrx/signals';
import {
    addEntity,
    removeAllEntities,
    removeEntity,
    setAllEntities,
    updateEntity,
    withEntities,
} from '@ngrx/signals/entities';
import { CountrySearch } from '../countries/countries.model';
import { Country, ICountry } from '../shared/model/address.model';

export const CountryStore = signalStore(
    { providedIn: 'root' },
    withDevtools('campus-country'),
    withEntities<ICountry>(),
    // To use localstorage : https://www.npmjs.com/package/@angular-architects/ngrx-toolkit
    //withStorageSync('campus-custom-parameter'),
    withComputed(store => ({
        size: computed(() => store.entities().length),
        loaded: signal<boolean>(false),
    })),
    withMethods(store => {
        const em = inject(EventManager);
        return {
            set(items: ICountry[]) {
                store.loaded.set(items.length > 0);
                patchState(store, setAllEntities([...items]));
            },

            create(item: ICountry) {
                patchState(store, addEntity({ ...item }));
            },

            remove(id: string) {
                patchState(store, removeEntity(id));
            },

            get(id: string) {
                return { ...store.entityMap()[id] };
            },

            update(item: Country) {
                patchState(store, updateEntity({ id: item.id, changes: { ...item } }));
            },

            findCode(code: string): Country {
                let result = null;
                store.ids().forEach(id => {
                    const item: Country = store.entityMap()[id];
                    if (item.code == code) {
                        result = { ...item };
                    }
                });
                em.httpEnd();
                return result;
            },

            findAll() {
                const result: Country[] = [];
                store.ids().forEach(id => {
                    const item: Country = store.entityMap()[id];
                    result.push({ ...item });
                });
                em.httpEnd();
                return result.sort((s1, s2) => s1.name.localeCompare(s2.name));
            },

            filter(search: CountrySearch): Country[] {
                console.log('STATE-SEARCH-DTO', search);
                const regex = new RegExp(search.name, 'i');
                const result: Country[] = [];
                store.ids().forEach(id => {
                    const item: Country = store.entityMap()[id];
                    if (
                        (!search.name || item.name.match(regex)) &&
                        (!search.code || item.code == search.code) &&
                        (search.hasState == undefined || item.hasState == search.hasState)
                    ) {
                        result.push({ ...item });
                    }
                });

                em.httpEnd();
                return result.sort((s1, s2) => s1.name.localeCompare(s2.name));
            },

            clear() {
                store.loaded.set(false);
                if (store.size() > 0) {
                    patchState(store, removeAllEntities());
                }
            },
        };
    })
);
